var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
if (!customElements.get("ac-number-input")) {
  class AcNumberInput extends HTMLElement {
    constructor() {
      super();
      this.attachShadow({ mode: "open" });
      this.shadowRoot.innerHTML = `
        <style>
          :host {
            display: inline-block;
            width: min-content;
          }

          ona-number-input::part(input) {
            font: inherit;
            padding: 0;
            text-align: center;
            background-color: transparent;
            border: none;
            color: inherit;
          }

          ona-number-input::part(button) {
            aspect-ratio: 1;
            padding: 0;
          }

          ona-number-input[data-variant="default"] {
            display: grid;
            grid-template-columns: 1fr min-content 1fr;
          }

          ona-number-input[data-variant="default"]::part(input) {
            font-size: 1.25rem;
            font-weight: 400;
            width: 2rem;
            aspect-ratio: 1;
          }

          ona-number-input[data-variant="default"]::part(button) {
            width: 2rem;
          }

          ona-number-input[data-variant="big"] {
            display: grid;
            grid-template-columns: min-content 1fr;
            gap: 0 1rem;
            width: min-content;
            align-items: start;
          }

          ona-number-input[data-variant="big"]::part(input) {
            width: 10.375rem;
            aspect-ratio: 166 / 135;
            grid-row: 1 / span 2;
            border: 3px solid var(--color-blue-400);
            border-radius: var(--border-radius-medium);
            font-size: var(--fs-headline-large);
            font-weight: 600;
            color: var(--color-topo-500);
          }

          ona-number-input[data-variant="big"]::part(button) {
            width: 3.75rem;
          }

          ona-number-input[data-variant="big"]::part(add-button) {
            align-self: start;
          }

          ona-number-input[data-variant="big"]::part(remove-button) {
            align-self: end;
            order: 2;
          }
        </style>
        <ona-number-input>
          <slot name="add" slot="add"></slot>
          <slot name="remove" slot="remove"></slot>
        </ona-number-input>
      `;
    }
    connectedCallback() {
      this.inner = this.shadowRoot.querySelector("ona-number-input");
      if (this.getAttribute("name")) {
        this.hiddenInput = document.createElement("input");
        if (this.getAttribute("form")) this.hiddenInput.setAttribute("form", this.getAttribute("form"));
        this.hiddenInput.type = "hidden";
        this.hiddenInput.name = this.getAttribute("name");
        this.hiddenInput.value = this.getAttribute("value");
        this.append(this.hiddenInput);
      }
      this._updateAttributes();
      this._delegateEvents();
    }
    attributeChangedCallback() {
      if (!this.inner) return;
      this._updateAttributes();
    }
    _updateAttributes() {
      for (const attr of ["name", "min", "max", "value", "disabled", "readonly", "debounce"]) {
        const val = this.getAttribute(attr);
        if (val !== null) {
          this.inner.setAttribute(attr, val);
        } else {
          this.inner.removeAttribute(attr);
        }
      }
      const variant = this.getAttribute("variant") === "big" ? "big" : "default";
      this.inner.setAttribute("data-variant", variant);
    }
    _delegateEvents() {
      this.inner.addEventListener("change", (e) => {
        if (this.hiddenInput) this.hiddenInput.value = e.detail.value;
        this.dispatchEvent(
          new CustomEvent("change", {
            detail: e.detail,
            bubbles: true,
            composed: true
          })
        );
      });
    }
    get value() {
      var _a;
      return (_a = this.inner) == null ? void 0 : _a.value;
    }
    set value(val) {
      if (this.inner) this.inner.value = val;
    }
  }
  __publicField(AcNumberInput, "observedAttributes", ["min", "max", "value", "disabled", "readonly", "debounce", "variant"]);
  customElements.define("ac-number-input", AcNumberInput);
}
